module.exports = __webpack_public_path__ + "zvetseni-rtu-permalip_4_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-rtu-permalip_4_after.jpg
// module id = 1379
// module chunks = 0